// extracted by mini-css-extract-plugin
export default {"container":"cH-z","header":"dH-z","details":"eH-z","link":"fH-z"};